import React from 'react';

export function Badge({ 
  children, 
  variant = 'default',
  size = 'md',
  className = '',
  ...props 
}) {
  const baseClasses = 'inline-flex items-center justify-center font-medium';
  
  const variants = {
    default: 'bg-secondary text-text-primary',
    primary: 'bg-primary text-white',
    accent: 'bg-accent text-white',
    success: 'bg-green-100 text-green-800 border border-green-200',
    warning: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    error: 'bg-red-100 text-red-800 border border-red-200',
    info: 'bg-blue-100 text-blue-800 border border-blue-200',
    outline: 'bg-transparent text-text-primary border border-border'
  };
  
  const sizes = {
    sm: 'px-2 py-0.5 text-xs rounded-md',
    md: 'px-2.5 py-1 text-sm rounded-lg',
    lg: 'px-3 py-1.5 text-base rounded-lg'
  };
  
  const variantClass = variants[variant] || variants.default;
  const sizeClass = sizes[size] || sizes.md;
  
  return (
    <span
      className={`${baseClasses} ${variantClass} ${sizeClass} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export function StatusBadge({ status, className = '' }) {
  const statusConfig = {
    active: { variant: 'success', children: 'Active' },
    inactive: { variant: 'error', children: 'Inactive' },
    pending: { variant: 'warning', children: 'Pending' },
    draft: { variant: 'outline', children: 'Draft' },
    published: { variant: 'primary', children: 'Published' },
    featured: { variant: 'accent', children: 'Featured' }
  };
  
  const config = statusConfig[status] || statusConfig.draft;
  
  return (
    <Badge variant={config.variant} className={className}>
      {config.children}
    </Badge>
  );
}

export default Badge;
